import styled from 'styled-components';

interface IProps {
    className?: string;
}

const BasePhoneIcon = ({ className }: IProps) => (
    <svg
        className={className}
        fill="black"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g>
            <path
                fill="currentColor"
                d="M18.034 24c-1.16 0-2.33-.33-3.38-.99-.01 0-.02-.01-.03-.02A50.42 50.42 0 0 1 1.007 9.375c-1.61-2.53-1.26-5.749.84-7.848l.77-.77a2.601 2.601 0 0 1 3.669 0l3.26 3.27c.48.48.759 1.149.759 1.829 0 .69-.27 1.35-.76 1.83-.43.429-.43 1.119 0 1.549l5.22 5.218c.41.41 1.129.41 1.549 0a2.601 2.601 0 0 1 3.67 0l3.259 3.259a2.6 2.6 0 0 1 0 3.669l-.77.77A6.297 6.297 0 0 1 18.033 24Zm-2.58-2.25c1.94 1.21 4.36.93 5.949-.65l.77-.769c.43-.43.43-1.12 0-1.55l-3.26-3.258c-.43-.43-1.12-.43-1.55 0-.98.98-2.689.98-3.669 0l-5.209-5.229a2.6 2.6 0 0 1 0-3.669c.21-.21.32-.48.32-.77 0-.29-.12-.57-.32-.77L5.226 1.818c-.43-.42-1.12-.43-1.55 0l-.77.77a4.74 4.74 0 0 0-.65 5.948A48.969 48.969 0 0 0 15.455 21.75Z"
            ></path>
        </g>
    </svg>
);

export const PhoneIcon = styled(BasePhoneIcon)``;
